import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import Modal from "react-bootstrap/Modal";
import { upsertCenter } from "../../../actions/center";
import { useEffect } from "react";
import { toast } from "react-toastify";
import TextField from "@mui/material/TextField";
import Switch from "@mui/material/Switch";
import { Grid, Input, MenuItem, Select, InputLabel } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import CountrySelect from "../../../CountrySelect";
import { Button } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LocalAirportIcon from "@mui/icons-material/LocalAirport";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PeopleIcon from '@mui/icons-material/People';
import TabPanel from "../../../TabPanel";
import LocalActivityIcon from '@mui/icons-material/LocalActivity';

import InputAdornment from '@mui/material/InputAdornment';
import InfoIcon from '@mui/icons-material/Info';

import UsersTab from './Tabs/UsersTab';
import AirportTab from './Tabs/AirportTab';
import WeeksTab from "./Tabs/WeeksTab";
import ExtraTab from "./Tabs/ExtraTab";
import AdressTab from "./Tabs/AdressTab";

import { getBankAccounts } from "../../../actions/bankaccount";


const CenterModal = (props) => {

  const tabHeight = 400;

  const dispatch = useDispatch();

  const form = useRef();
  const checkBtn = useRef();
  
  const { bankaccounts: bankAccounts } = useSelector((state) => state.bankaccounts);

  const [name, setName] = useState("");
  const [address_one, setAddressOne] = useState("");
  const [address_two, setAddressTwo] = useState("");
  const [zip_code, setZipCode] = useState("");
  const [locality, setLocality] = useState("");
  const [country, setCountry] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [price_per_week, setPricePerWeek] = useState(0);
  const [price_extra_per_day, setPriceExtraPerDay] = useState(0);
  const [currency, setCurrency] = useState(1);
  const [um_price, setUmPrice] = useState(0);
  const [id, setID] = useState(0);
  const [include_kids, setIncludeKids] = useState(0);
  const [active, setActive] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("")
  const [transfer_price, setTransferPrice] = useState(0);

  const [centerUsers, setCenterUsers] = useState([]);
  const [centerWeeks, setCenterWeeks] = useState([]);
  const [centerAirports, setCenterAirports] = useState([]);
  const [centerExtras, setCenterExtras] = useState([]);

  const [tabValue, setTabValue] = React.useState(0);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const [abbreviation, setAbbreviation] = useState(false);

  const [bankAccount, setBankAccount] = useState(null);

  const [trainingProgramPrice1, setTrainingProgramPrice1] = useState(0);
  const [trainingProgramPrice2, setTrainingProgramPrice2] = useState(0);
  const [trainingProgramPrice3, setTrainingProgramPrice3] = useState(0);
  const [trainingProgramPrice4, setTrainingProgramPrice4] = useState(0);

  const { centers: listCenters } = useSelector((state) => state.centers);

  const clearUI = () => {
    setEmail("");
    setName("");
    setAddressOne("");
    setAddressTwo("");
    setZipCode("");
    setLocality("");
    setCountry("");
    setEmail("");
    setWebsite("");
    setPriceExtraPerDay(0);
    setPricePerWeek(0);
    setCurrency(0);
    setUmPrice(0);
    setIncludeKids(false);
    setActive(0);
    setCenterAirports([])
    setCenterUsers([])
    setCenterWeeks([])
    setCenterExtras([])
    setTransferPrice(0)
    setID(0)
    setTrainingProgramPrice1(0)
    setTrainingProgramPrice2(0)
    setTrainingProgramPrice3(0)
    setTrainingProgramPrice4(0)
    props.updateSelectedCenter(null);
  };


  useEffect(() => {
    if (props.show && props.currentCenterDTO != null && !loaded) {
      listCenters
        .filter((currentCenterDTO) => {
          return (
            currentCenterDTO.id === props.currentCenterDTO.id
          );
        })
        .map(
          (currentCenterDTO) => (
            setEmail(currentCenterDTO.email),
            setName(currentCenterDTO.name),
            setAddressOne(currentCenterDTO.adress),
            setAddressTwo(currentCenterDTO.adress2),
            setZipCode(currentCenterDTO.zipcode),
            setLocality(currentCenterDTO.locality),
            setActive(currentCenterDTO.active),
            setID(currentCenterDTO.id),
            setCountry(currentCenterDTO.country),
            setCurrency(currentCenterDTO.currency),
            setPricePerWeek(currentCenterDTO.pricePerWeek),
            setPriceExtraPerDay(currentCenterDTO.priceExtraPerDay),
            setIncludeKids(currentCenterDTO.includeKids),
            setWebsite(currentCenterDTO.website),
            setUmPrice(currentCenterDTO.umPrice),
            setTransferPrice(currentCenterDTO.transferPrice),
            setCenterAirports(currentCenterDTO.airports ? currentCenterDTO.airports : []),
            setCenterUsers(currentCenterDTO.users),
            setCenterExtras(currentCenterDTO.extras),
            setCenterWeeks(currentCenterDTO.weeks),
            setAbbreviation(currentCenterDTO.abbreviation),
            setBankAccount(currentCenterDTO.idBankAccount),
            setTrainingProgramPrice1(currentCenterDTO.trainingProgramPrice1),
            setTrainingProgramPrice2(currentCenterDTO.trainingProgramPrice2),
            setTrainingProgramPrice3(currentCenterDTO.trainingProgramPrice3),
            setTrainingProgramPrice4(currentCenterDTO.trainingProgramPrice4)
          )
        );

      setLoaded(true);
    }

    if (!props.show && props.currentCenterDTO) {
      clearUI();
      setLoaded(false);
    }
  });

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      setLoading(true);

      let center_dto = { center: {}, airports: [] };

      if (props.currentCenter != null) center_dto = props.currentCenter;
      else center_dto.id = 0;

      center_dto.name = name;
      center_dto.adress = address_one;
      center_dto.adress2 = address_two;
      center_dto.zipcode = zip_code;
      center_dto.zipcode = zip_code;
      center_dto.locality = locality;
      center_dto.country = country;
      center_dto.email = email;
      center_dto.website = website;
      center_dto.pricePerWeek = price_per_week;
      center_dto.priceExtraPerDay = price_extra_per_day;
      center_dto.currency = currency;
      center_dto.umPrice = um_price;
      center_dto.includeKids = include_kids;
      center_dto.active = active;
      center_dto.transferPrice = transfer_price;
      center_dto.IDBankAccount = bankAccount;
      center_dto.abbreviation = abbreviation;
      
      center_dto.trainingProgramPrice1 = trainingProgramPrice1;
      center_dto.trainingProgramPrice2 = trainingProgramPrice2;
      center_dto.trainingProgramPrice3 = trainingProgramPrice3;
      center_dto.trainingProgramPrice4 = trainingProgramPrice4;

      console.log(center_dto)
      
      center_dto.weeks = centerWeeks.map(week => {
        if (week.id < 0) return { ...week, id: 0 };
        return week;
      });
      center_dto.extras = centerExtras.map(extra => {
        if (extra.id < 0) return { ...extra, id: 0 };
        return extra;
      });
      center_dto.airports = centerAirports;
      center_dto.id = id;

      console.log(center_dto)

      dispatch(upsertCenter(center_dto))
        .then(() => {
          toast.success(
            `Centre ${center_dto.id > 0 ? "updated" : "created"
            } successfuly`,
            { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
          );
          setLoading(false);
        })
        .catch((e) => {
          console.log(e)
          toast.error(
            `An Error occured while updating the centre. Try again later.`,
            { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
          );
          setLoading(false);
        });

      props.onHide();
    } else {
      setLoading(false);
    }
  };

  return (
    <Modal {...props} size="xl"  >
      <Form onSubmit={handleSubmit} ref={form}>
        <Modal.Header closeButton>
          <Grid container>
            <Grid item>
              <Modal.Title>Edit Centre</Modal.Title>
            </Grid>
          </Grid>
          <FormControlLabel control={<Switch checked={active} onChange={(e) => setActive(e.target.checked)} disabled={!props.admin}/>} />
        </Modal.Header>

        <Modal.Body>
          <Grid container spacing={1}>

            <Grid item xs={12}>
              <Tabs value={tabValue} onChange={handleTabChange}>
                <Tab icon={<InfoIcon />} aria-label="adress" />
                <Tab icon={<PeopleIcon />} aria-label="people" />
                <Tab icon={<CalendarMonthIcon />} aria-label="calendarMonth" />
                <Tab icon={<LocalActivityIcon />} aria-label="localActivities" />
                <Tab icon={<LocalAirportIcon />} aria-label="localAirport" />
              </Tabs>

              <TabPanel value={tabValue} index={0} height={tabHeight}>
                <AdressTab
                  name={name} setName={setName}
                  email={email} setEmail={setEmail}
                  website={website} setWebsite={setWebsite}
                  phoneNumber={phoneNumber} setPhoneNumber={setPhoneNumber}
                  address_one={address_one} setAddressOne={setAddressOne}
                  address_two={address_two} setAddressTwo={setAddressTwo}
                  locality={locality} setLocality={setLocality}
                  zip_code={zip_code} setZipCode={setZipCode}
                  country={country} setCountry={setCountry}
                  currency={currency} setCurrency={setCurrency}
                  price_per_week={price_per_week} setPricePerWeek={setPricePerWeek}
                  price_extra_per_day={price_extra_per_day} setPriceExtraPerDay={setPriceExtraPerDay}
                  um_price={um_price} setUmPrice={setUmPrice}
                  include_kids={include_kids} setIncludeKids={setIncludeKids}
                  transfer_price={transfer_price} setTransferPrice={setTransferPrice}
                  admin={props.admin}
                  abbreviation={abbreviation} setAbbreviation={setAbbreviation}
                  bankAccounts={bankAccounts} bankAccount={bankAccount} setBankAccount={setBankAccount}
                  trainingProgramPrice1={trainingProgramPrice1} setTrainingProgramPrice1={setTrainingProgramPrice1}
                  trainingProgramPrice2={trainingProgramPrice2} setTrainingProgramPrice2={setTrainingProgramPrice2}
                  trainingProgramPrice3={trainingProgramPrice3} setTrainingProgramPrice3={setTrainingProgramPrice3}
                  trainingProgramPrice4={trainingProgramPrice4} setTrainingProgramPrice4={setTrainingProgramPrice4}
                />
              </TabPanel>

              <TabPanel value={tabValue} index={1} height={tabHeight}>
                <UsersTab centerUsers={centerUsers} admin={props.admin}/>
              </TabPanel>

              <TabPanel value={tabValue} index={2} height={tabHeight}>
                <WeeksTab currentCenterID={id} centerWeeks={centerWeeks} setCenterWeeks={setCenterWeeks} admin={props.admin}/>
              </TabPanel>

              <TabPanel value={tabValue} index={3} height={tabHeight}>
                <ExtraTab currentCenterID={id} centerExtras={centerExtras} setCenterExtras={setCenterExtras} currency={currency} admin={props.admin}/>
              </TabPanel>

              <TabPanel value={tabValue} index={4} height={tabHeight}>
                <AirportTab centerAirports={centerAirports} setCenterAirports={setCenterAirports} admin={props.admin}/>
              </TabPanel>
            </Grid>

            <CheckButton style={{ display: "none" }} ref={checkBtn} />
          </Grid>
        </Modal.Body>

        <Modal.Footer>
          <Grid container spacing={3}>

            <Grid item xs={6}>
              <Button variant="outlined" onClick={props.onHide} sx={{ width: '100%' }}>Close</Button>
            </Grid>
            <Grid item xs={6}>
              <Button variant="contained" onClick={handleSubmit}  sx={(props.admin) ? { display: "block", width: '100%' } : { display: "none", width: '100%' }}>
                Save
              </Button>
            </Grid>

          </Grid>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CenterModal;
